import { useEffect, useState } from 'react';
import "./MainSectionInsta.css";

function MainSectionInsta() {
    const [widgetLoaded, setWidgetLoaded] = useState(false);

    useEffect(() => {
        let script;
        let interval;
        let resizeObserver;

        
        if (!document.querySelector('script[src="https://static.elfsight.com/platform/platform.js"]')) {
            script = document.createElement('script');
            script.src = 'https://static.elfsight.com/platform/platform.js';
            script.async = true;
            script.defer = true;
            script.onload = () => setWidgetLoaded(true);
            document.body.appendChild(script);
        } else {
            setWidgetLoaded(true);
        }

        // Correzione stile widget
        const fixWidgetOverlap = () => {
            const widget = document.querySelector('.elfsight-app-1aeabd26-b9bb-43f5-87ae-a088f1fe3271');
            if (widget) {
                widget.style.position = 'relative';
                widget.style.zIndex = '0';
                clearInterval(interval);
                setWidgetLoaded(true);
                
                
                resizeObserver = new ResizeObserver((entries) => {
                    entries.forEach(entry => {
                        
                    });
                });
                resizeObserver.observe(widget);
            }
        };

        fixWidgetOverlap();
        interval = setInterval(fixWidgetOverlap, 500);

        return () => {
            clearInterval(interval);
            if (resizeObserver) resizeObserver.disconnect();
            
        };
    }, []);

    return (
        <section className='Insta' id='Insta'>
            <div className="insta-container">
                <div className="insta-header">
                    <h2>Follow us</h2>
                    <p>Join our community on Instagram for daily inspiration! Tag us and share <a
                        href="https://www.instagram.com/explore/tags/positanonboard/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hashtag">
                        #positanonboard
                    </a></p>
                </div>

                <div className="insta-profile">
                    {!widgetLoaded && (
                        <div className="insta-placeholder">
                            Loading Instagram feed...
                        </div>
                    )}
                    <div
                        className="elfsight-app-1aeabd26-b9bb-43f5-87ae-a088f1fe3271"
                        data-elfsight-app-lazy
                    ></div>
                </div>
            </div>
        </section>
    );
}

export default MainSectionInsta;